import { useState } from 'react';
import { CopyAltIcon, CopyedAltIcon } from './icon';

type CopyToClipboardProps = {
  onClick: () => void;
};

export const CopyToClipboard = (props: CopyToClipboardProps) => {
  const { onClick } = props;
  const [isCopied, setIsCopied] = useState(false);

  const handleClick = () => {
    onClick();
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <div className="ml-2 cursor-pointer" onClick={handleClick}>
      {isCopied ? (
        <CopyedAltIcon className="w-4 h-4 text-[#155DFC]" />
      ) : (
        <CopyAltIcon className="w-4 h-4 text-[#155DFC]" />
      )}
    </div>
  );
};
